var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lighten, Stack, TableCell as MuiTableCell } from "@mui/material";
import TableRow from "../TableRow";
import { AutocompleteChip } from "../../../../Atoms";
import { COLORS } from "../../../../../constants";
var TagRow = function (_a) {
    var tagsData = _a.tagsData, rowId = _a.rowId, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, bgcolor = _a.bgcolor, hasCheckbox = _a.hasCheckbox;
    var tags = (tagsData === null || tagsData === void 0 ? void 0 : tagsData.tags) || [];
    if (tags.length === 0) {
        return null;
    }
    var tagsToShow = (tagsData === null || tagsData === void 0 ? void 0 : tagsData.tagsToShow) || 2;
    var showCountTag = tags.length > tagsToShow;
    var countTagValue = "+".concat(tags.length - tagsToShow);
    var columnsBefore = (tagsData === null || tagsData === void 0 ? void 0 : tagsData.columnsBefore) || 0;
    var columnsAfter = (tagsData === null || tagsData === void 0 ? void 0 : tagsData.columnsAfter) || 0;
    return (_jsxs(TableRow, __assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "data-testid": "".concat(rowId, "-row-tags"), sx: {
            borderBottom: "1px solid ".concat(lighten(COLORS.BLACK, 0.9)),
            bgcolor: bgcolor,
        } }, { children: [columnsBefore > 0 && _jsx(MuiTableCell, { colSpan: columnsBefore }), _jsx(MuiTableCell, __assign({ sx: {
                    pt: hasCheckbox ? 0 : 2,
                    ":first-of-type": {
                        pl: 6,
                    },
                } }, { children: _jsxs(Stack, __assign({ direction: "row" }, { children: [tags.slice(0, tagsToShow).map(function (tag) { return (_jsx(AutocompleteChip, { option: __assign({}, tag), sx: { mr: 2, mb: 2 } }, tag.id)); }), showCountTag && (_jsx(AutocompleteChip, { option: {
                                id: tagsToShow + 1,
                                name: countTagValue,
                                color: "WHITE",
                            }, sx: { mr: 2, mb: 2 } }))] })) })), columnsAfter > 0 && _jsx(MuiTableCell, { colSpan: columnsAfter })] })));
};
export default TagRow;
